import s from './style.module.scss';
import { useCallback, useEffect, useState } from 'react';
// import useStatusBarHeight from '@/hooks/useStatusBarHeight';
// import cx from 'classnames';
import { useTranslation } from 'react-i18next';

export default function Questionnaire(props) {
  const { setAnswerDic, setShowConfirm, answerDic } = props;
  const { t } = useTranslation();

  const [answer, setAnswer] = useState();
  const handleInputChange = useCallback((e) => {
    setAnswerDic(Object.assign(answerDic, { q4: e.target.value }));
    setAnswer(e.target.value);
    setShowConfirm(e.target.value.length >= 10);
  }, []);

  useEffect(() => {
    setShowConfirm(answerDic.q4?.length > 10);
  }, [answerDic]);

  return (
    <div className={s.root}>
      <div className={s.title}>{t('DUET_QUESTIONNAIRE_Q4')}</div>
      <div className={s.answerWrapper}>
        <textarea
          placeholder={t('DUET_QUESTIONNAIRE_Q2_ENTER')}
          className={s.answerItem}
          minLength={10}
          maxLength={500}
          value={answer} // 将输入框的值绑定到组件的状态
          onChange={handleInputChange}
        />
      </div>
    </div>
  );
}
